import request from "@/util/request"

export interface LeftMenu {
    title: string;
    lat: number;
    lng: number;
    uid: string;
    showEdit?:boolean;
}

export interface point {
    code?: string;//船舶标识
    title: string;
    point: number[];
    phone: string;
    address?: string;
    desc?: string
    // 仓库信息
    store?: store[]
    // 船舶
    shipping?: shipping

    gate?: gate[]
}
// 码头
export interface store extends LeftMenu {
    address: string;
    desc: string;
    add_time: string;
    store: storeInfo[]
}
// 码头上的仓库
export interface storeInfo {
    store_id: string; //仓库编号
    store_name: string; //仓库名称
    store_simple_name: string; //仓库简称
    store_managers: string; //仓库管理员
    phone: string; //仓库联系电话
    lat: number; //仓库纬度
    lng: number; //仓库经度
    operator: string; //经办人
    create_at: string; //添加时间
    edit_at: string; //编辑时间
    remark: string; //仓库备注
    wharf_no: string; //码头编号
    sky: Sky[]
}
export interface Sky {
    prod_id: string;//产品编码
    prod_name: string;//产品名称
    prod_size: string;//产品规格
    unit_name: string;//单位
    class_ex_id: string;//类别代码
    class_name: string; //类别名称
    ware_id: string;//仓库ID
    ware_house_name: string;//仓库名称
    quantity: string;//数量
    name: string;//码头名称
    address: string;//码头地址
}
export interface goods {
    lease: string;//租赁编号
    u_name: string;//名称
    order_no: string;//采购单号
    loading_port: string;//装货港口
    un_loading_port: string;//抵达港口
    loading_part: string;//发货单位
    insurance: number;//货物保险
    loading_time: number;//装船时间
    ship_time: number;//发船时间
    end_time: number;//到港时间
    un_loading_time: number;//卸货时间
    supplier_no: string;//供应商编码
    supplier_user: string;//供应商联系人
    supplier_phone: string;//供应商电话
    sale_no: string;//销售单号
    client_no: string;//客户名称
    client_user: string;//客户联系人
    client_phone: string;//客户电话
    goods_name: string;//货物名称
    goods_no: string;//产品编码  
    operations_manager: string;//业务经理
    operations_phone: string;//联系电话
    operator: string;//经办人
    operator_phone: string;//经办人电话 
    lease_date: string;//租赁日期
    edit_time: string;//编辑时间
    goods_weight: number;//货物重量
    goods_cost: number;//成本单价
    goods_price: number;//货物价值
    transport_price: number;//运输单价
    sale_price: number;//销售单价
    supplier: string;//水泥供应商名称 
    desc: string;//备注

}
export interface shipping extends LeftMenu {
    loading_time: string//装船时间
    start_time: string;//发船时间
    end_time: string;//预到时间
    unloading_time: string;//卸货时间
    // 轮船货物信息
    goods?: goods[],
    // 同步库返回结果
    uid: string;
    title: string;
    mmsi: string;
    imo: string;
    callsign: string;
    shiptype: string;
    length: string;
    width: string;
    left: string;
    trail: string;
    draught: string;
    contact: string;
    phone: string;
    memo: string;
    owner: string;
    add_time: string;
    update_time: string;
    comment: string;
    status: number;
    put_status: number
}
export interface gate extends LeftMenu {
    add_time: string
}
export interface customAddr extends LeftMenu {
    address: string
    desc:string
    status:number
}
// 轮船轨迹
export interface track {
    utc: number;//时间戳
    utc_text: string;
    lat: number;//纬度	1/1000000 度
    lon: number;//经度	1/1000000 度
    cog: number;//航迹向	1/100 度
    sog: number;//速度	毫米/秒
}
// 顶部统计
export interface Statistical {
    total: number;//数量
    tonnage: number;//吨位
}
export interface ShipSearch {
    uid: string;
    u_name: string;
    u_def_1: string;
    u_def_2: string;
    u_def_3: string;
    u_def_4: string;
    u_def_5: string;
    u_def_6: string;
    u_def_7: number;
    u_def_8: number;
    u_def_29: number;
    u_def_30: number;
    u_def_12: string;
    u_def_13: string;
    u_def_14: number;
    u_def_15: string;
    u_def_16: string;
    u_def_17: string;
    u_def_18: string;
    u_def_19: string;
    u_def_20: string;
    u_def_21: string;
    u_def_22: string;
    u_def_23: string;
    u_def_24: string;
    u_def_27: number;
    u_def_28: number;
    u_def_43: number;
    u_def_45: number;
    u_def_47: number;
    u_def_44: number;
    u_def_46: number;
    u_def_48: number;
    u_def_25: string;
    memo: string;
    u_def_41: number;
    u_def_42: number;

}
export const login = (user_name: string, password: string): Promise<string> => {
    return request({ url: "/pub/login", method: "POST", data: { user_name, password } })
}
export const getStatistical = (): Promise<{ ship_count: Statistical, store_count: Statistical }> => {
    return request({ url: "/admin/count", method: "POST" })
}
// 发货分类types:0全部,4喆优,5福盈
export const getShip = (keywords = "", types = 0): Promise<{ list: shipping[], total: number }> => {
    let ship_type = ""
    switch (types) {
        case 4:
            ship_type = "喆优"
            break
        case 5:
            ship_type = "福盈"
            break
        default:
            ship_type = ""
    }
    return request({ url: "/admin/ship_list", method: "POST", data: { keywords, ship_type, page_size: 50 } })
}

// 获取仓库
export const getStore = (): Promise<{ list: store[], total: number }> => {
    return request({ url: "/admin/store_list", method: "POST" })
}
// 删除仓库货物
export const delStoreGoods = (id: number): Promise<any> => {
    return request({ url: "/store_del_store", data: { id }, method: "POST" })
}
// 保存仓库
export const saveStore = (data: point): Promise<any> => {
    return request({ url: "/store_save", data, method: "POST" })
}
// 删除仓库
export const delStore = (id: number): Promise<any> => {
    return request({ url: "/store_del", data: { id }, method: "POST" })
}
// 获取闸机
export const getGate = (): Promise<Promise<{ list: gate[], total: number }>> => {
    return request({ url: "/admin/gate_list", method: "POST" })
}
// 编辑闸机
export const saveGate = (data: point): Promise<any> => {
    return request({ url: "/gate_save", data, method: "POST" })
}
// 获取轨迹
export const getPath = (code: string, time_range_start: string, time_range_end: string): Promise<{ list: track[], import_point: track[] }> => {
    return request({ url: "/admin/ship_track", method: "POST", data: { ship_id: code, time_range_end, time_range_start } })
}
// 发货时间
export const delivery = (code: string, start: string, end: string): Promise<goods[]> => {
    return request({ url: "/admin/delivery", method: "POST", data: { ship_id: code, start, end } })
}
// 自定义点列表
export const customList = (page=1,page_size=1000): Promise<{list:customAddr[]}> => {
    return request({ url: "/admin/custom_list", method: "POST", data: { page,page_size } })
}
// 自定义地点编辑
export const customEdit = (data:customAddr): Promise<goods[]> => {
    return request({ url: "/admin/custom_edit", method: "POST", data })
}
// 船舶搜索
export const shipSearch = (search: ShipSearch, page = 1, page_size = 10,
    u_def_7_s = "", //装船时间
    u_def_7_e = "",
    u_def_8_s = "", //发船时间
    u_def_8_e = "",
    u_def_29_s = "",//到港时间
    u_def_29_e = "",
    u_def_30_s = "",//卸货时间
    u_def_30_e = ""): Promise<{ list: ShipSearch[], total: number,weight:number }> => {
    return request({
        url: "/admin/ship_search", method: "POST", data: {
            ...search, page, page_size, 
            u_def_7_s, //装船时间
            u_def_7_e,
            u_def_8_s, //发船时间
            u_def_8_e,
            u_def_29_s,//到港时间
            u_def_29_e,
            u_def_30_s,//卸货时间
            u_def_30_e
        }
    })
}